import { t } from '../../utils/ui-strings';

interface TryOnButtonProps {
  onClick: () => void;
  className?: string;
  lang?: string;
}

/**
 * "Prova med AI"-knappen på produktkortet. Bara en knapp — modalen ägs av
 * ProductSlider (en modal för hela senaste renderingen) så att plagg kan
 * bytas i resultatvyn utan att bilden laddas upp igen.
 */
export function TryOnButton({ onClick, className, lang }: TryOnButtonProps) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={
        className ??
        'inline-block w-full rounded border border-brand-blue px-3 py-2 text-center text-[11px] uppercase tracking-[0.05em] text-brand-blue transition-colors duration-200 hover:bg-brand-blue hover:text-white'
      }
    >
      {t('try_on_button', lang)}
    </button>
  );
}
